<template>
  <div class="">
    <Landing :landingData="landingData" />
    <AboutInstructor id="about" :instructorData="instructorData" />
    <ProgramInfo id="program" :info="programData" />
    <BasicRequirement :info="basicRequirement" />
    <PositionSummary :info="positionInfo" />
    <TestimonialCompany :info="companyTestimonial" style="padding-top:40px" />
    <Faq id="faq" :info="faq" />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>
<script>
import AboutInstructor from '../../components/AssessmentIsa/AboutTheCompany.vue'
import TestimonialCompany from '../../components/AssessmentIsa/CompanyTestimonial.vue'
import Landing from '../../components/AssessmentIsa/LandingAssessment.vue'
import ProgramInfo from '../../components/AssessmentIsa/ProgramInfo.vue'
import Contact from '../../components/isaMain/Contact.vue'
import PositionSummary from '../../components/AssessmentIsa/PositionSummary.vue'
import BasicRequirement from '../../components/AssessmentIsa/BasicReq.vue'
import Faq from '../../components/shera/Faq.vue'

export default {
  data() {
    return {
      landingData: {
        title1: 'BE A PRODUCT DESIGNER AT TRUCK LAGBE',
        //   subTitle: 'Senior Marketing Executive (Contractual)',
        paragraph:
          'Get Hired as a Product designer at Truck Lagbe by applying through the assessment curated by upskill. salary: 30,000 - 55, 000 BDT ',
        companyLogo: '',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/b955ff97-e483-4282-96d2-7b99247c6721?public=true&job=TruckLagbe-ProductDesigner',
        landingImage:
          'https://upskill-frontend.s3.ap-southeast-1.amazonaws.com/HrApp+Assets/Product+Designer.png',
        // spanColor: 'grey',
      },
      instructorData: {
        //   name: 'Fayaz Taher',
        avatar:
          'https://www.trucklagbe.com/hs-fs/hubfs/raw_assets/public/TruckLagbe_July2020/images/main_logo_1.png?width=4096&name=main_logo_1.png',
        info:
          'Truck Lagbe is a technology platform optimising how Bangladesh books trucks. It connects businesses and customers to the right drivers and fleet owners for their hauling needs.',
        designation: '',

        bgColor: 'white',
        txtColor: 'black',
      },
      programData: {
        headingInfo:
          'The assessment consists of 15 MCQS. You are required to pass the assessment test with a minimum of 60% of the total score. Top 5-10 Candidates will get the chance to go to the interview round after completing the assessment.',
        startDate: '17th April',
        deadline: '23rd April',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        bgColor: '#1EBCE5',
        txtColor: '#5277F7',
      },

      basicRequirement: {
        mainContent: [
          ' Strong portfolio that shows you have knowledge in both Web & Mobile app design.',
          ' Minimum 2 years of experience in UI/UX design or product design-related field.',
          ' Excellent attention to detail.',
          ' Ability to communicate design concepts clearly.',
          ' Good understanding of color, typography, and combinations.',
          ' Knows Figma very well',
        ],
        bgColor: '#333333',
      },

      outlineColor: {
        color: '#33333',
      },

      faq: [
        {
          title: 'What is the duration of the assessment? \n',
          content: '10 minutes. \n',
          category: 'FAQ',
        },
        {
          title: 'What is the assessment  fee? \n',
          content: 'It is free',
          category: 'FAQ',
        },
        {
          title: 'Do you need previous work experience? \n',
          content: 'Yes, 2 years on UX/UI design or product related field\n',
          category: 'FAQ',
        },
        {
          title: 'How much do I need to secure to qualify?\n',
          content: '60% of the total score i.e. 9 out of 15',
          category: 'FAQ',
        },

        {
          title: 'How many times can I take the quiz?\n',
          content:
            'You can take the quiz twice. The highest score will be counted as the final score.\n',
          category: 'FAQ',
        },
        // {
        //   title: 'Will all the top 5 students get a job at  Truck lagbe?\n',
        //   content:
        //     'No, the top 5 students will get a chance to interview at Truck lagbe and will get the job depending on their performance in the interview.\n',
        //   category: 'FAQ',
        // },
        {
          title: 'Salary?\n',
          content: '30,000 - 55, 000 BDT /Month \n',
          category: 'FAQ',
        },
      ],
    }
  },
  components: {
    Landing,
    AboutInstructor,
    Faq,
    ProgramInfo,
    Contact,
    TestimonialCompany,
    BasicRequirement,
    PositionSummary,
  },
  created() {
    this.Loaded()
  },
}
</script>
